import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import api from "../../util/api";
import swal from "sweetalert";

import "react-bootstrap-table-next/dist/react-bootstrap-table2.min.css";
import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory from "react-bootstrap-table2-paginator";

import Footer from "../common/Footer";
import Header from "../common/Header";
import Sidebar from "../common/Sidebar";

const Transactions = () => {
    const navigate = useNavigate();

    const [transactions, setTransactions] = useState([]);
    const [totalVolume, setTotalVolume] = useState(0);
    const [successfulTxns, setSuccessfulTxns] = useState(0);

    useEffect(() => {
        getTransactions();
    }, []);

    async function getTransactions() {
        const token = localStorage.getItem("token");
        try {
            const res = await api.get("/admin/transactions", {
                headers: {
                    "Authorization": `Bearer ${token}`,
                },
            });
            if (res.data.success) {
                setTransactions(res.data.transactions);

                const total = res.data.transactions.reduce((acc, curr) => acc + parseFloat(curr.amount || 0), 0);
                setTotalVolume(total);

                const successCount = res.data.transactions.filter(t => t.status === "successful" || t.status === "success").length;
                setSuccessfulTxns(successCount);
            }
        } catch (err) {
            swal("Failed to fetch transactions!", "error", {
                button: false,
                timer: 1500
            });
        }
    }

    const columns = [
        {
            dataField: "reference",
            text: "Reference",
            sort: true,
            formatter: (cell) => <span className="fw-bold">{cell}</span>
        },
        {
            dataField: "customer_name",
            text: "Customer",
            sort: true,
            formatter: (cellContent, row) => (
                <span>{row.firstname} {row.lastname}</span>
            )
        },
        {
            dataField: "amount",
            text: "Amount",
            sort: true,
            formatter: (cell) => (
                <span>₦{parseFloat(cell).toLocaleString()}</span>
            )
        },
        {
            dataField: "type",
            text: "Type",
            sort: true,
            formatter: (cell) => (
                <span className="text-capitalize">{cell}</span>
            )
        },
        {
            dataField: "status",
            text: "Status",
            sort: true,
            formatter: (cell) => {
                let badgeClass = "bg-secondary";
                if (cell === "successful" || cell === "success") badgeClass = "bg-success";
                if (cell === "pending") badgeClass = "bg-warning text-dark";
                if (cell === "failed") badgeClass = "bg-danger";

                return <span className={`badge ${badgeClass}`}>{cell}</span>;
            }
        },
        {
            dataField: "created_at",
            text: "Date",
            sort: true
        },
        {
            text: "Action",
            formatter: (cellContent, row) => (
                <button
                    onClick={() => navigate('/transaction-details', { state: { transaction: row } })}
                    className="btn btn-sm btn-outline-primary"
                >
                    Details
                </button>
            )
        }
    ];

    return (
        <div>
            <Header />
            <Sidebar />
            <main id="main" className="main">
                <div className="pagetitle">
                    <h1>Transactions</h1>
                    <nav>
                        <ol className="breadcrumb">
                            <li className="breadcrumb-item"><a href="/">Home</a></li>
                            <li className="breadcrumb-item active">Transactions</li>
                        </ol>
                    </nav>
                </div>

                <section className="section dashboard">
                    <div className="row">
                        <div className="col-lg-12">
                            <div className="row">

                                <div className="col-xxl-4 col-md-6">
                                    <div className="card info-card sales-card">
                                        <div className="card-body">
                                            <h5 className="card-title">Total Count</h5>
                                            <div className="d-flex align-items-center">
                                                <div className="card-icon rounded-circle d-flex align-items-center justify-content-center">
                                                    <i className="bi bi-cart" />
                                                </div>
                                                <div className="ps-3">
                                                    <h6>{transactions.length}</h6>
                                                    <span className="text-muted small pt-2 ps-1">Total Transactions</span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div className="col-xxl-4 col-md-6">
                                    <div className="card info-card revenue-card">
                                        <div className="card-body">
                                            <h5 className="card-title">Total Volume</h5>
                                            <div className="d-flex align-items-center">
                                                <div className="card-icon rounded-circle d-flex align-items-center justify-content-center">
                                                    <i className="bi bi-currency-exchange" />
                                                </div>
                                                <div className="ps-3">
                                                    <h6>₦{totalVolume.toLocaleString()}</h6>
                                                    <span className="text-muted small pt-2 ps-1">Cumulative Value</span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div className="col-xxl-4 col-xl-12">
                                    <div className="card info-card customers-card">
                                        <div className="card-body">
                                            <h5 className="card-title">Successful</h5>
                                            <div className="d-flex align-items-center">
                                                <div className="card-icon rounded-circle d-flex align-items-center justify-content-center">
                                                    <i className="bi bi-check-circle" />
                                                </div>
                                                <div className="ps-3">
                                                    <h6>{successfulTxns}</h6>
                                                    <span className="text-muted small pt-2 ps-1">Completed Successfully</span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div className="col-12">
                                    <div className="card recent-sales overflow-auto">
                                        <div className="card-body">
                                            <h5 className="card-title">Transaction History <span>| All Time</span></h5>
                                            <BootstrapTable
                                                bootstrap4
                                                keyField="id"
                                                data={transactions}
                                                columns={columns}
                                                bordered={false}
                                                pagination={paginationFactory({
                                                    sizePerPage: 20,
                                                    hideSizePerPage: false,
                                                    hidePageListOnlyOnePage: true
                                                })}
                                            />
                                        </div>
                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>
                </section>
            </main>
            <Footer />
            <a href="#" className="back-to-top d-flex align-items-center justify-content-center"><i className="bi bi-arrow-up-short" /></a>
        </div>
    );
};

export default Transactions;